import React from 'react';
import PropTypes from 'prop-types';
import { Text, TEXT_VARIANTS } from 'ui/Typography';

import ReplyContainer from '../Learner/ReplyContainer';

const WrittenResponseQuestion = props => {
  const { isDisabled, saveAnswer, data, meta } = props;
  const { givenAnswer = '' } = data;
  const { previewing = false } = meta;
  return (
    <div className="pl-32 pr-32">
      <Text className="mt-0" variant={TEXT_VARIANTS.BODY_BOLD}>
        {t('questions.question.written_response.instructions')}
      </Text>
      <ReplyContainer
        previewing={previewing}
        questionType={data.questionType}
        isDisabled={isDisabled}
        data={data}
        givenAnswer={givenAnswer}
        updateMessage={saveAnswer}
      />
    </div>
  );
};

WrittenResponseQuestion.propTypes = {
  isDisabled: PropTypes.bool,
  saveAnswer: PropTypes.func,
  data: PropTypes.shape({
    isGradable: PropTypes.bool,
    questionId: PropTypes.number,
    progressId: PropTypes.number,
    questionType: PropTypes.string,
    required: PropTypes.bool,
    subject: PropTypes.string,
    isPractice: PropTypes.bool,
  }),
  meta: PropTypes.shape({
    finished: PropTypes.bool,
    previewing: PropTypes.bool,
  }),
};

export default WrittenResponseQuestion;
